import { cn } from '@/common-utils/libraries/tailwind/utils';
import Entity from '../entity/Entity';
import Icon from '../icon/Icon';
import PropTypes from 'prop-types';

/**
 * @param root0
 * @param root0.icon
 * @param root0.entity
 * @param root0.namespace
 * @param root0.variant
 * @param root0.className
 * @returns {JSX} Info
 */
function Info({ icon, entity, namespace, variant, className }) {

    // Constants
    const variants = {
        info: 'text-info bg-info/20',
        success: 'text-success bg-success/20',
        warning: 'text-warning bg-warning/20',
        danger: 'text-danger bg-danger/20',
        default: 'text-secondary bg-secondary/20'
    };
    const infoVariant = variants[variant] ?? 'default';

    return (
        <div className={cn('flex items-center gap-2  p-4 mt-2 rounded', className, infoVariant)}>
            <Icon icon={icon} />
            <Entity entity={entity} namespace={namespace} className='text-[inherit]' />
        </div>
    );
}

Info.propTypes = {
    icon: PropTypes.string.isRequired,
    entity: PropTypes.string.isRequired,
    namespace: PropTypes.string,
    variant: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'default']),
    className: PropTypes.string
};

export default Info;